var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticStyle:{"display":"none"},attrs:{"id":"type"},domProps:{"innerHTML":_vm._s(_vm.type)}})
}
var staticRenderFns = []

export { render, staticRenderFns }